[...document.getElementsByClassName('bloomreach-widget')].forEach(el =>{
  if(el.classList.contains('initialized')){return} 
  el.classList.add('initialized');
  initializeBloomreachWidget(el);
});

function initializeBloomreachWidget(el) {

  const widgetType = el.querySelector('.bloomreach-widget-container').dataset.widgetType;
  const widgetPid = el.querySelector('.bloomreach-widget-container').dataset.widgetPid;

  let apiType = 'item';
  let widgetId = 'kjy78w1j';

  if (widgetType === 'complete-the-look') {
    apiType = 'item';
    widgetId = 'kjy78w1j';
  }

  if (widgetType === 'ymal') {
    apiType = 'item';
    widgetId = '2l73q4zj';
  }

  if (widgetType === 'recently-viewed') {
    apiType = 'personalized';
    widgetId = 'ojdx24m9';
  }

  //console.log('---------apiType', apiType)
  let BRResults = null;

  function randomId() {
    return String(Math.floor(1e12 + Math.random() * 9e12));
  }

  function getCookie(key) {
    const cookies = document.cookie.split('; ');
    const cookie = cookies.find(c => c.startsWith(key + '='));
    return cookie ? cookie.split('=')[1] : null;
  }

  let _br_uid_2 = getCookie('_br_uid_2');

  if (_br_uid_2) {
    _br_uid_2 = decodeURIComponent(_br_uid_2);
  } else {
    _br_uid_2 = '';
  }

  const params = new URLSearchParams({
    account_id: '8258',
    // auth_key: 'hdrkqdeih5uyrcu6',
    domain_key: 'amiri',
    request_id: randomId(),
    _br_uid_2: _br_uid_2,
    url: window.location.href,
    rows: 16,
    fields: 'pid,title,url',
    // request_type: 'search',
    // q: category,
    //item_ids: brContextPid,
    //context_pids: brContextPid
  });

  if (widgetType === 'complete-the-look' || widgetType === 'ymal') {
    params.set('item_ids', widgetPid )
    params.set('context_pids', widgetPid )
  }

  fetch(`https://pathways.dxpapi.com/api/v2/widgets/${apiType}/${widgetId}?${params}`)
  .then((res) => res.json())
  .then((result) => {
    console.log('bloomreach result', result)
    BRResults = result;
    renderCollectionResults();
  })

  function renderCollectionResults() {
    if (BRResults && BRResults.response && BRResults.response.docs) {

      const products = BRResults.response.docs;

      products.forEach((product, index) => {
        const li = document.createElement("div");
        // li.className = 'grid__item';
        li.className = 'splide__slide';

        // li.id = `pid-${product.pid}`;
        li.dataset.pid = `pid-${product.pid}`;
        el.querySelector('.bloomreach-widget-list').appendChild(li);
      });
      
      products.forEach((product, index) => {

        const handle = product.url.split('/products/')[1];
        getProductCardHTMLByHandle(handle, product.pid, index);
      });
      initSplide()
    }

    ////////////////////////////////////
    // getProductCardHTMLByHandle
    ////////////////////////////////////

    function getProductCardHTMLByHandle(handle, pid, position) {
      //console.log('handle', handle)
      let url = `${window.Shopify.routes.root}products/${handle}?view=productcard`;
      fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        if (responseText.indexOf('404 Not Found') == -1) {
          // document.getElementById(`pid-${pid}`).innerHTML = html;
          el.querySelector(`[data-pid="pid-${pid}"]`).innerHTML = html;
        } 
      });
    }
  }

  function initSplide() {
    const splide = new Splide( `#${el.id} .splide`, {                                  
      pagination: false,
      arrows: true,
      perPage: 8,        
      gap: '2px',   
      perMove: 1,                     
      keyboard: true,                                  
      snap: false,
      // pauseOnHover: true,
      // pauseOnFocus: true,                                                  
      breakpoints: {
        768: {              
          destroy: true
          // perPage: 1,
          // padding: { left: '15px', right:'20%' },        
          // gap: '1px',
          // arrows: false,
          // pagination: false
        }
      }
    });            

    splide.on('ready', function () {
      el.querySelectorAll('[aria-roledescription]').forEach(el => {
        el.setAttribute('aria-label', el.getAttribute('aria-roledescription'))
        el.removeAttribute('aria-roledescription')
      })      
    });

    splide.mount();      
  }

}
